(() => {
  if (window.__cahveFeaturedCollectionBooted) return;
  window.__cahveFeaturedCollectionBooted = true;

  const SELECTOR = '[data-cahve-featured-collection]';

  const revealSection = (section) => {
    if (!section || section.dataset.cahveFcInitialized === 'true') return;

    section.dataset.cahveFcInitialized = 'true';
    const cards = Array.from(section.querySelectorAll('[data-cahve-fc-card]'));

    if (!cards.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      cards.forEach((card) => card.classList.add('is-cahve-visible'));
      return;
    }

    if (!('IntersectionObserver' in window)) {
      cards.forEach((card) => card.classList.add('is-cahve-visible'));
      return;
    }

    section.dataset.cahveFcReady = 'true';

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;

        cards.forEach((card) => card.classList.add('is-cahve-visible'));
        observer.disconnect();
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.08,
      }
    );

    observer.observe(section);
  };

  const initialize = (root = document) => {
    if (root.matches?.(SELECTOR)) revealSection(root);
    root.querySelectorAll?.(SELECTOR).forEach(revealSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('cahve:product-recommendations:loaded', (event) => initialize(event.detail?.root));
})();
